/**
 * A page's floating dock (Shell `dock`) - e.g. a custom report's actions row.
 * Docked in the shell, not drawn by the page, because only the shell's
 * scroller can pin it to the window (prototype `App.tsx`).
 */
import type { AppRoute } from '@/app/router/registry';
import { ReportActionsDock } from '@/features/reports';

export function PageDock({ kind }: { kind: NonNullable<AppRoute['dock']> }) {
  switch (kind) {
    case 'report-actions':
      return <ReportActionsDock />;
  }
}
